import { apiClient } from './api-client';

export interface UploadedImage {
  url: string;
  key: string;
  size: number;
}

/**
 * Upload a profile image via the shared platform uploads endpoint
 * (S3-backed, public-readable so the embedded widget can load it). The
 * returned `url` is what we persist (e.g. on EngageBotConfig.avatarUrl).
 */
export async function uploadImage(args: {
  file: File;
  scope: string;
  ownerId?: string;
}): Promise<UploadedImage> {
  const fd = new FormData();
  fd.append('file', args.file);
  fd.append('scope', args.scope);
  if (args.ownerId) fd.append('ownerId', args.ownerId);
  // Let axios set the multipart boundary by passing FormData; the response
  // interceptor unwraps { success, data } → data.
  const { data } = await apiClient.post<UploadedImage>(
    '/platform/uploads/image',
    fd,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return data;
}
